import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{ background: 'linear-gradient(to bottom, #0A0E14 0%, #111827 100%)' }}>
      {/* Professional Grid */}
      <div className="absolute inset-0 pro-grid opacity-50"></div>
      
      {/* Ambient Glows - Adjusted for mobile */}
      <div className="ambient-glow absolute top-10 md:top-20 left-10 md:left-20 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-green-500"></div>
      <div className="ambient-glow absolute bottom-10 md:bottom-20 right-10 md:right-20 w-[500px] md:w-[700px] h-[500px] md:h-[700px] bg-emerald-500" style={{ animationDelay: '5s' }}></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-24 md:py-32 text-center">
        {/* Badge */}
        <div className="inline-block mb-6 md:mb-8 animate-fade" style={{ opacity: 0, animationDelay: '0.1s' }}>
          <div className="px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-green-500/20 bg-green-500/5 backdrop-blur-sm">
            <span className="text-green-400 text-[10px] md:text-xs font-medium">
              Trusted by 500+ developers across India
            </span>
          </div>
        </div>

        {/* Main Title */}
        <h1 className="mb-6 md:mb-8 animate-fade-up" style={{ opacity: 0, animationDelay: '0.2s' }}>
          <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-3 md:mb-4 text-white leading-tight">
            Cloud Infrastructure
          </div>
          <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight">
            <span className="text-green-400">Made for India</span>
          </div>
        </h1>

        {/* Subtitle */}
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-400 mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed px-4 animate-fade-up" 
          style={{ opacity: 0, animationDelay: '0.3s' }}>
          Enterprise-grade cloud platform designed for developers.
          <br className="hidden sm:block" />
          <span className="hidden sm:inline"> </span>Simple pricing, powerful features, local performance.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-12 md:mb-20 px-4 animate-fade-up" style={{ opacity: 0, animationDelay: '0.4s' }}>
          <Button
            onClick={() => scrollToSection('cta')}
            size="lg"
            className="bg-green-500 hover:bg-green-400 text-black w-full sm:w-auto px-8 md:px-10 py-5 md:py-6 text-sm md:text-base font-semibold transition-all duration-200 shadow-lg shadow-green-500/20 hover:shadow-green-500/30"
          >
            Get Started Free
            <ArrowRight className="ml-2" size={18} />
          </Button>
          <Button
            onClick={() => scrollToSection('features')}
            size="lg"
            variant="outline"
            className="border-gray-700 text-gray-300 hover:bg-white/5 hover:border-gray-600 w-full sm:w-auto px-8 md:px-10 py-5 md:py-6 text-sm md:text-base font-medium"
          >
            View Features
          </Button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-5xl mx-auto px-4">
          {[
            { value: '₹499', label: 'Starting at' },
            { value: '99.99%', label: 'Uptime SLA' },
            { value: '<50ms', label: 'Avg Latency' },
            { value: '5 Cities', label: 'Data Centers' }
          ].map((stat, index) => (
            <div 
              key={index} 
              className="animate-scale" 
              style={{ opacity: 0, animationDelay: `${0.6 + index * 0.1}s` }}
            >
              <div className="glass-card p-4 md:p-6 rounded-lg md:rounded-xl hover:border-green-500/30 transition-all duration-300">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-green-400 mb-1">
                  {stat.value}
                </div>
                <div className="text-[10px] md:text-xs text-gray-500 font-medium uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};